import { useAudio } from "@/contexts/audio-context";
import { CallTranscriptionType } from "@/types/voice/call_transcription";
import { groupConversation } from "@/utils/group-segments";
import { forwardRef, useEffect, useRef, useState } from "react";
import { ChatMessage } from "../calls/chat-message";
import { ChatSearch } from "../calls/chat-search";

type AudioTranscription2Props = {
    transcription: CallTranscriptionType;
};

export const AudioTranscription2 = forwardRef(function AudioTranscription2({ transcription }: AudioTranscription2Props) {
    const transcriptContainerRef = useRef<HTMLDivElement>(null);
    const groupedSegments = groupConversation(transcription);
    const [searchTerm, setSearchTerm] = useState("");
    const [highlightedMessageTime, setHighlightedMessageTime] = useState<number | null>(null);
    const { currentTime, setCurrentTime } = useAudio();

    const handleMessageClick = (timestamp: number) => {
        // Mettre à jour le contexte audio pour déclencher la navigation
        setCurrentTime(timestamp);
    };

    const activeIndex =
        currentTime > 0 ? groupedSegments.reduce((active, group, index) => (group.startTime <= currentTime ? index : active), -1) : -1;

    useEffect(() => {
        if (activeIndex < 0) return;
        transcriptContainerRef.current?.querySelectorAll<HTMLElement>("[data-start-time]")[activeIndex]?.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest"
        });
    }, [activeIndex]);

    return (
        <div className="mt-4 flex w-full flex-col gap-4">
            <div className="flex w-full items-center justify-end">
                {transcription?.status === "completed" && (
                    <ChatSearch
                        segments={groupedSegments}
                        onMessageClick={handleMessageClick}
                        onSearchTermChange={setSearchTerm}
                        onHighlightedMessageChange={setHighlightedMessageTime}
                        className="flex-shrink-0"
                    />
                )}
            </div>

            {transcription?.status === "completed" && (
                <div ref={transcriptContainerRef} className="chat-conversation chat-message-container max-h-[calc(100vh-350px)] w-full space-y-3 overflow-y-auto overflow-x-hidden">
                    {groupedSegments.map((group, index) => (
                        <ChatMessage key={`group-${index}`} group={group} onMessageClick={handleMessageClick} searchTerm={searchTerm} isHighlighted={index === activeIndex || highlightedMessageTime === group.startTime} />
                    ))}
                </div>
            )}
        </div>
    );
});
